import noData from '../assets/animations/TableLoader.json';
import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';


export const TableLoader = ({ message = "Loading...." }) => {

    return (
        <Box sx={{
            display: 'flex',
            flexDirection:"column",
            justifyContent: 'center',
            alignItems: 'center',
        }}
        >
            <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
                <Lottie
                    animationData={noData}
                    loop={true}
                    size={300}
                    style={{ height: '', width: '200px' }}
                />
                <Typography sx={{color:"black",fontSize:"12px",fontWeight:700}}>{message}</Typography>
            </div>
        </Box>
    );
};